/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import legalPageStyle from "assets/jss/views/legalPage/legalPageStyle";
const useStyles = makeStyles(legalPageStyle);

import { getDoc, ApricotAction } from "client/actions/modal";
import { progressCircles } from "components/Form/FormField";

interface Props {
  getDoc: ApricotAction;
  docTerms: string;
  onShowPolicy?: () => void;
  classes: any;
}

const TermsBase: React.FC<Props> = ({
  getDoc,
  docTerms,
  onShowPolicy,
}: Props) => {
  const classes = useStyles();
  useEffect(() => {
    docTerms === null && getDoc(1);
  }, []);

  const HtmlToReactParser = require("html-to-react").Parser;
  const parser = new HtmlToReactParser();

  const renderShowPolicy = () => {
    const sPriPolicy = "Privacy Policy";
    if (onShowPolicy) {
      return (
        <a style={{ cursor: "pointer" }} onClick={onShowPolicy}>
          {sPriPolicy}
        </a>
      );
    } else {
      return <Link to="/lgl/policy">{sPriPolicy}</Link>;
    }
  };

  return docTerms ? (
    <div className={classes.content}>
      <div className={classes.title}>Terms of Use</div>
      <p>
        These Terms apply to all your activities on the Apricad.com (the “
        <b>Site</b>”). We also provide details regarding our processing of
        personal data of our students {renderShowPolicy()}.
      </p>
      {parser.parse(docTerms)}
      <p className={classes.ending}>&sect;</p>
    </div>
  ) : (
    progressCircles()
  );
};

function mapStateToProps(state: any) {
  return {
    docTerms: state.state_modal.docTerms,
  };
}

const base: any = TermsBase;
const Terms = connect(mapStateToProps, { getDoc })(base);
export default Terms;
